angular.module('iqxCore')
    .service('ErrorReporterSvc', function ($http, $q, ApplicationSvc, SweetAlert, toastSvc, $location, $timeout) {
        var svc = this


        svc.report = function (error, options, additionalOptions) {
            var text = ""
            var number = 1
            if (error.iqxError) {
                number = error.iqxError.errorNumber || 1
                text = "IQXWeb ERROR " + number + ":~" + error.iqxError.text
            } else if (error.data) {
                text = "HTTP ERROR " + error.status + ":~" + error.statusText
            } else {
                text = 'Web Server Unavailable'
            }

            if (number >= 100) {
                userErrorAlert(error.iqxError.text)
            } else if (!navigator.onLine) {
                userOffline()
            } else if (error.data && error.status === 401) { // This occurs if a user has multiple sessions open and then change their password.
                sessionExpired()
            } else if (ApplicationSvc.checkRights(['IQXWEBDEBUG'])) {
                // has debug right, display full error
                displayFullError(text, error, options, additionalOptions)
            } else {
                // system error, send bug report and display nice message
                internalErrorAlert()
                sendBugReport(text, error, options)
            }
            return $q.reject(error) // return rejected promise with error object as rejection reason
        }

        function userErrorAlert(msg) {
            // this is a user error (just information) - noooo need for bug report!
            SweetAlert.swal({
                title: "Error",
                text: msg,
                type: "info"
            })
        }

        function userOffline() {
            toastSvc.error('Offline', 'You are no longer connected to the internet.', 'offlineToast')
        }

        function sessionExpired() {
            SweetAlert.swal({
                title: "Your session has expired",
                text: "Please login again.",
                confirmButtonText: "Login",
                showCancelButton: false,
                type: "warning"
            }).then(function () {
                $timeout(function () {
                    if (ApplicationSvc.isApp !== true) {
                        $location.path('/login')
                    } else {
                        window.location.href = "/login"
                    }
                })
            })
        }

        function internalErrorAlert() {
            SweetAlert.swal({
                title: "Error",
                text: "An error has occured, please try refreshing the page.  If the error persists please contact the agency.",
                type: "info"
            })
        }

        function sendBugReport(text, error, options) {
            var errorReportObj = {
                company: ApplicationSvc.params.BROWSERTITLE,
                webversion: ApplicationSvc.params.version,
                docker: ApplicationSvc.params.docker,
                userclass: (ApplicationSvc.currentUser.UserClass ? ApplicationSvc.currentUser.UserClass : 'GUEST'),
                userrights: (ApplicationSvc.currentUser.UserRights ? ApplicationSvc.currentUser.UserRights.join(", ").toLowerCase() : ''),
                URL: window.location.href,
                error_returned: text,
                options: JSON.stringify(options),
                screensize: window.innerWidth + 'x' + window.innerHeight,
                browsermeta: navigator.appVersion + " | " + navigator.language + " | " + navigator.vendor,
                type: "api"
            }
            $http.post('/api/sendReport/error', JSON.stringify(errorReportObj))
        }

        function displayFullError(text, error, options, additionalOptions) {
            var errorReportObj = {
                company: ApplicationSvc.params.BROWSERTITLE,
                webversion: ApplicationSvc.params.version,
                docker: ApplicationSvc.params.docker,
                userclass: (ApplicationSvc.currentUser.UserClass ? ApplicationSvc.currentUser.UserClass : 'GUEST'),
                userrights: (ApplicationSvc.currentUser.UserRights ? ApplicationSvc.currentUser.UserRights.join(", ").toLowerCase() : ''),
                currentuser: ApplicationSvc.currentUser.UserName,
                URL: window.location.href,
                error_returned: JSON.stringify(text, null, 2),
                options: JSON.stringify(options),
                additionalOptions: JSON.stringify(additionalOptions),
                fullError: JSON.stringify(error),
                screensize: window.innerWidth + 'x' + window.innerHeight,
                browsermeta: navigator.appVersion + " | " + navigator.language + " | " + navigator.vendor
            }

            var errorReportHTML = ""
            errorReportHTML = errorReportHTML + '<div class="table-responsive"><table class="table table-bordered table-condensed" style="font-size:12px; text-align:left;">'
            angular.forEach(errorReportObj, function (value, key) {
                errorReportHTML = errorReportHTML + "<tr><td>" + key + "</td><td>" + value + "</td></tr>"
            })
            errorReportHTML = errorReportHTML + "</table></div>"

            SweetAlert.swal({
                title: "An Internal Error Has Occurred",
                html: errorReportHTML,
                confirmButtonText: "Close"
            })
        }

    })